<template>
  <g class="not-copy">
    <foreignObject :x="x" :y="y" height="100" width="100">
      <img :style="transform" src="@/assets/virtualoffice/interior/monitor1.png" class="img-icon" xmlns="http://www.w3.org/1999/xhtml"/>
    </foreignObject>
    <rect :x="x" :y="y" height="100" width="100" fill="transparent"/>
  </g>
</template>

<script>
import { mapState } from 'vuex'
export default {
  name: 'Monitor',
  componentName: 'Monitor',
  props: ['x', 'y', 'transform'],
}
</script>

<style lang="scss" scoped>
.img-icon {
  width: 100px;
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/views/DashBoard/VirtualOffice/Interior/Monitor.vue